import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import useUbi from '@di-shared/features/ubi/useUbi';

export const IRRECOVERABLE_CLOSE_DUE_DATE = 'IRRECOVERABLE_CLOSE_DUE_DATE';
export const CLOSE_DAYS = 7;
const STANDARD_SCORE = 60;

export interface SafeDrivingIrrecoverableBottomSheetKrProps {
  vin: string;
}

function SafeDrivingIrrecoverableBottomSheetKr({vin}: SafeDrivingIrrecoverableBottomSheetKrProps) {
  const {t} = useInferableTranslation();

  const {displayInsurancesData, ubiData} = useUbi({vin});

  function closeBottomSheetSevenDays() {
    // 7일 동안 보지 않기
    localStorage.setItem(IRRECOVERABLE_CLOSE_DUE_DATE, new Date().toString());
    window.bottomSheetClose(false);
  }

  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2
          className="bottom_sheet_title"
          style={{whiteSpace: 'pre-wrap'}}
        >
          {t('T20175_$score', {score: STANDARD_SCORE - ubiData.safetyDrvScore})}
        </h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose(false)}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          ></span>
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T20176_$discount', {discount: displayInsurancesData[0].totalDiscount})}</strong>
        </div>

        <div className="bottom_sheet_footer bottom_sheet_footer_vertical">
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => window.bottomSheetClose(true)}
          >
            {t('T20177')}
          </button>

          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => {
              closeBottomSheetSevenDays();
            }}
          >
            {t('T20178')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default SafeDrivingIrrecoverableBottomSheetKr;
